import * as React from "react";
import "./Tooltip.css";

export const Tooltip = ({ children, ClassName = "" }) => {
    return (
        <span className={`tooltip ${ClassName}`}>{children}</span>
    );
};



// WEBPACK FOOTER //
// ./src/components/Tooltip/Tooltip.tsx